// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 99;
}

.top {
    position: absolute;
    top: 38px;
    height: calc(100% - 38px);
    width:100%;
}
.left-active {
    position:absolute;
    left: 300px;
    width: calc(100% - 300px);
    top: 38px;
    height: calc(100% - 38px);
}
.loading {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #0000007a;
    z-index: 9;
    color: white;
    display:flex;
    justify-content:center;
}
.notPermitted {
    background-color: white;
    z-index: 1;
}

.layoutEdit {
    background: white;
    z-index: 100;
    overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/lib/appframework.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,yBAAyB;IACzB,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,SAAS;IACT,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,sBAAsB;AAC1B;AACA;IACI,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,cAAc;AAClB","sourcesContent":[".overlay {\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    z-index: 99;\n}\n\n.top {\n    position: absolute;\n    top: 38px;\n    height: calc(100% - 38px);\n    width:100%;\n}\n.left-active {\n    position:absolute;\n    left: 300px;\n    width: calc(100% - 300px);\n    top: 38px;\n    height: calc(100% - 38px);\n}\n.loading {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #0000007a;\n    z-index: 9;\n    color: white;\n    display:flex;\n    justify-content:center;\n}\n.notPermitted {\n    background-color: white;\n    z-index: 1;\n}\n\n.layoutEdit {\n    background: white;\n    z-index: 100;\n    overflow: auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
